import { Table } from "@tanstack/react-table";
import { TBody, TCell, TRow } from "@theprelude/ds";
import { getGridTemplateColumns } from "./hooks";

export const LoadingTable = ({
  table,
  rowCount,
}: {
  table: Table<any>;
  rowCount: number;
}) => {
  const cols = table.getVisibleFlatColumns();
  const gridTemplateColumns = getGridTemplateColumns(table);

  return (
    <TBody>
      {Array.from({ length: rowCount }).map((_, i) => (
        <TRow
          key={i}
          style={{
            gridTemplateColumns,
          }}
        >
          {cols.map((_, j) => (
            <TCell key={j}>
              <div className="my-1 h-2 w-2/3 animate-pulse rounded-md bg-secondary-background" />
            </TCell>
          ))}
        </TRow>
      ))}
    </TBody>
  );
};
